export const contactEn = {
  hero: {
    title: 'Contact Us',
    subtitle: "We're here to answer your questions and welcome your feedback",
  },
  getInTouch: {
    title: 'Get In Touch',
    subtitle: "Have a question, suggestion, or want to book a table? We'd love to hear from you.",
    location: 'Our Location',
    phone: 'Phone',
    email: 'Email',
    hours: 'Opening Hours',
    hoursDetails: {
      weekdays: 'Monday - Saturday: 12:00 - 22:00',
      sunday: 'Sunday: 17:00 - 22:00',
    },
  },
  form: {
    title: 'Send Us a Message',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    subject: 'Subject',
    message: 'Message',
    button: 'Send Message',
    confirmation: 'Your message has been sent successfully. We will get back to you soon!',
    defaultNote: 'We will get back to you as soon as possible.',
    placeholders: {
      name: 'Your full name',
      email: 'Your email address',
      phone: 'Your phone number (optional)',
      subject: 'What is this regarding?',
      message: 'Your message',
    },
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our restaurant',
    items: [
      {
        question: 'Do you take reservations?',
        answer:
          'Yes, we highly recommend making a reservation, especially for dinner and weekends. You can book a table through our website, by phone, or by email.',
      },
      {
        question: 'Do you offer vegetarian and vegan options?',
        answer:
          'Yes, we have several vegetarian options marked on our menu. While traditional Neapolitan cuisine often includes dairy, we can adapt many dishes to be vegan upon request.',
      },
      {
        question: 'Can you accommodate guests with allergies or dietary restrictions?',
        answer:
          'Absolutely. Please inform us of any allergies or dietary restrictions when making your reservation, and our chefs will be happy to accommodate your needs.',
      },
      {
        question: 'Do you have parking facilities?',
        answer:
          "While we don't have a private parking lot, there is street parking available nearby and several public parking garages within walking distance.",
      },
    ],
  },
};
